import React from 'react';
import classnames from 'classnames';
import s from './BackgroundImage.scss';
export var BackgroundImage = function (_a) {
    var src = _a.src, blur = _a.blur, subtleBlur = _a.subtleBlur, fade = _a.fade, className = _a.className, imageClassName = _a.imageClassName;
    return (React.createElement("div", { className: classnames(s['root'], blur && s['blur'], subtleBlur && s['subtle-blur'], fade && s['fade'], fade && s["fade-".concat(fade)], className) },
        React.createElement("div", { className: classnames(s['image'], imageClassName), style: {
                backgroundImage: "url('".concat(src, "')"),
            } })));
};
BackgroundImage.displayName = 'BackgroundImage';
export default BackgroundImage;
//# sourceMappingURL=BackgroundImage.js.map